import { createSlice } from '@reduxjs/toolkit'
import listenerMiddleware from 'listenerMiddleware'

import * as modalFormSelector from 'selectors/modalForm'

import {
  NOTIFICATION_TYPE_SUCCESS,
} from 'constants/notification'

const initialState = {
  text: null,
  type: NOTIFICATION_TYPE_SUCCESS,
}

export const notificationModalSlice = createSlice({
  name: 'notificationModal',
  initialState,

  reducers: {
    addNotification: (state, action) => {
      state.text = action.payload.text || null
      state.type = action.payload.type || NOTIFICATION_TYPE_SUCCESS
    },

    clearNotification: (state, action) => {
      return initialState
    },
  },
})

export const {
  addNotification,
  clearNotification,
} = notificationModalSlice.actions

export default notificationModalSlice.reducer


// Listeners

listenerMiddleware.startListening({
  matcher: (action) => {
    return Boolean(action?.payload?.message?.text)
  },
  effect: (action, listenerApi) => {
    const state = listenerApi.getState()
    const isModalVisible = modalFormSelector.isVisible(state)
    const isModalOperationActive = modalFormSelector.operationActive(state)
    const showInModal = isModalVisible && isModalOperationActive && action.payload.error

    if (showInModal) {
      const { text, type } = action.payload.message
      listenerApi.dispatch(addNotification({
        text,
        type,
      }))
    }
  },
})
